import { formatODataDate } from 'omni-package-react-cms';
import { FieldsDetailsDto } from '../../interfaces/dto/FieldsDetailsDto';
import { NewsDetailsDto } from '../../interfaces/dto/NewsDetailsDto';
import { NewsDetails } from '../../interfaces/NewsDetails';

export default function transformNewsDetailsData(newsDetailsDto: NewsDetailsDto): NewsDetails {
  if (!newsDetailsDto) return null;
  const content = (fieldsDetailsDto: FieldsDetailsDto[]) => fieldsDetailsDto.find((f) => f?.Name === 'Content')?.Value;
  const title = (fieldsDetailsDto: FieldsDetailsDto[]) => fieldsDetailsDto.find((f) => f?.Name === 'Title')?.Value;
  const activationDate = (fieldsDetailsDto: FieldsDetailsDto[]) => fieldsDetailsDto.find((f) => f?.Name === 'Activation Date')?.Value;

  const details = {
    Content: content(newsDetailsDto.Fields),
    ActivationDate: new Date(formatODataDate(activationDate(newsDetailsDto.Fields))),
    Title: title(newsDetailsDto.Fields),
  };
  return details;
}
